export default "__VITE_ASSET__c5e2ca6b__"